/**
 * @Author: zhangkaicheng
 * @Date: 2026-01-19
 * @LastEditors: zhangkaicheng
 * @LastEditTime: 2026-01-19
 * @Description: PUGC投稿平台菜单栏
 */
export const baseMods = [
  {
    id: '1',
    title: '专家',
    accountInfo: null,
    path: '/service/mediacloud-reporter/expert-review-manage',
    identifyType: 'expert',
    default: 'el-icon-review-manage',
    active: 'el-icon-review-manage-active',
    disabled: true,
    children: [
      {
        id: '1-1',
        title: '评选管理',
        path: '/service/mediacloud-reporter/expert-review-manage',
        identifyType: 'expert',
        default: 'el-icon-review-manage',
        active: 'el-icon-review-manage-active',
        disabled: false,
        children: [
          {
            id: '1-1-1',
            path: '/service/mediacloud-reporter/expert-review-manage',
            identifyType: 'expert',
            title: '评选管理',
            disabled: true,
            childrenPath: []
          },
        ]
      },
      {
        id: '1-2',
        title: '账号设置',
        path: '/service/mediacloud-reporter/expert-authentication',
        identifyType: 'expert',
        default: 'el-icon-setting',
        active: 'el-icon-setting-active',
        disabled: false,
        children: [
          {
            id: '1-2-1',
            path: '/service/mediacloud-reporter/expert-authentication',
            identifyType: 'expert',
            title: '认证资料',
            disabled: false,
            childrenPath: []
          }
        ]
      },
    ]
  },
  {
    id: '2',
    title: '通讯员',
    accountInfo: null,
    path: '/service/mediacloud-reporter/compositionManage',
    identifyType: 'correspondent',
    default: 'el-icon-review-manage',
    active: 'el-icon-review-manage-active',
    disabled: false,
    children: [
      {
        id: '2-1',
        title: '投稿管理',
        path: '/service/mediacloud-reporter/compositionManage',
        identifyType: 'correspondent',
        default: 'el-icon-manuscript',
        active: 'el-icon-manuscript-active',
        disabled: false,
        children: [
          {
            id: '2-1-1',
            path: '/service/mediacloud-reporter/compositionManage',
            identifyType: 'correspondent',
            title: '作品管理',
            disabled: false,
            childrenPath: [
              '/service/mediacloud-reporter/articleText',
              '/service/mediacloud-reporter/articlePics',
              '/service/mediacloud-reporter/articleVideos'
            ]
          }
        ]
      },
      {
        id: '2-2',
        title: '公告通知',
        path: '/service/mediacloud-reporter/notice',
        identifyType: 'correspondent',
        default: 'el-icon-notice',
        active: 'el-icon-notice-active',
        disabled: false,
        children: [
          {
            id: '2-2-1',
            path: '/service/mediacloud-reporter/notice',
            identifyType: 'correspondent',
            title: '公告管理',
            disabled: true,
            childrenPath: []
          },
        ]
      },
      {
        id: '2-3',
        title: '账号设置',
        path: '/service/mediacloud-reporter/authentication',
        identifyType: 'correspondent',
        default: 'el-icon-setting',
        active: 'el-icon-setting-active',
        disabled: false,
        children: [
          {
            id: '2-3-1',
            path: '/service/mediacloud-reporter/authentication',
            identifyType: 'correspondent',
            title: '认证资料',
            disabled: false,
            childrenPath: []
          }
        ]
      },
    ]
  },
  {
    id: '3',
    title: '自媒体',
    accountInfo: null,
    path: '/service/mediacloud-reporter/compositionManage-weMedia',
    identifyType: 'we_media',
    default: 'el-icon-review-manage',
    active: 'el-icon-review-manage-active',
    disabled: true,
    children: [
      {
        id: '3-1',
        title: '投稿管理',
        path: '/service/mediacloud-reporter/compositionManage-weMedia',
        identifyType: 'we_media',
        default: 'el-icon-manuscript',
        active: 'el-icon-manuscript-active',
        disabled: false,
        children: [
          {
            id: '3-1-1',
            path: '/service/mediacloud-reporter/compositionManage-weMedia',
            identifyType: 'we_media',
            title: '作品管理',
            disabled: false,
            childrenPath: [
              '/service/mediacloud-reporter/articleText',
              '/service/mediacloud-reporter/articlePics',
              '/service/mediacloud-reporter/articleVideos'
            ]
          }
        ]
      },
      // {
      //   id: '3-2',
      //   title: '公告通知',
      //   path: '/service/mediacloud-reporter/notice',
      //   identifyType: 'we_media',
      //   default: 'el-icon-notice',
      //   active: 'el-icon-notice-active',
      //   disabled: false,
      //   children: [
      //     {
      //       id: '3-2-1',
      //       path: '/service/mediacloud-reporter/notice',
      //       identifyType: 'we_media',
      //       title: '公告管理',
      //       disabled: true,
      //       childrenPath: []
      //     },
      //   ]
      // },
      {
        id: '3-3',
        title: '账号设置',
        path: '/service/mediacloud-reporter/authentication',
        identifyType: 'we_media',
        default: 'el-icon-setting',
        active: 'el-icon-setting-active',
        disabled: false,
        children: [
          {
            id: '3-3-1',
            path: '/service/mediacloud-reporter/authentication',
            identifyType: 'we_media',
            title: '认证资料',
            disabled: false,
            childrenPath: []
          }
        ]
      }
    ]
  },
]